<template>
    <div class="kt-portlet kt-portlet--height-fluid kt-portlet--mobile container-fluid animated fadeInUp">
        <div class="kt-portlet__body kt-portlet__body--fit pt-2">
            <div class="col-12 pb-0">
                <vue-content-loading :height="1" :width="50" class="pt-3">
                    <rect x="0" y="0" rx="0" ry="0" width="50" height="50" />
                </vue-content-loading>
            </div>
            <div class="row p-0 m-0">
                <div class="col-md-6 col-sm-6 col-12">
                    <vue-content-loading :height="2" :width="4" class="pt-3 pb-3">
                        <rect x="0" y="0" rx="0" ry="0" width="50" height="50" />
                    </vue-content-loading>
                </div>
                <div class="col-md-6 col-sm-6 col-12">
                    <vue-content-loading :height="160" :width="400" class="pt-3 pb-3">
                        <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
                        <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
                        <rect x="0" y="45" rx="4" ry="4" width="400" height="10" />
                        <rect x="0" y="65" rx="4" ry="4" width="400" height="9" />
                        <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
                        <rect x="0" y="93" rx="4" ry="4" width="100" height="8" />
                        <rect x="0" y="110" rx="4" ry="4" width="400" height="10" />
                    </vue-content-loading>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueContentLoading from 'vue-content-loading';
    export default {
        name: "spinner-linea",
        components:{
            VueContentLoading
        }
    }
</script>

<style scoped>

</style>
